import React, { FC, ReactNode } from "react";

import styles from "./landing.module.scss";

type Props = {
  topNavbar: ReactNode;
  splashScreen: ReactNode;
  howItWorks: ReactNode;
  plans: ReactNode;
  planDetails: ReactNode;
  morePlans: ReactNode;
  footer: ReactNode;
};

export const Landing: FC<React.PropsWithChildren<Props>> = (props) => {
  const {
    topNavbar,
    splashScreen,
    howItWorks,
    plans,
    planDetails,
    morePlans,
    footer,
  } = props;

  return (
    <div className={styles.root}>
      {topNavbar}

      {splashScreen}
      {plans}
      {howItWorks}

      {planDetails}
      {morePlans}

      {footer}
    </div>
  );
};
